// @flow
import { reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { compose } from 'react-recompose';
import ValidateEmail from './ValidateEmail';
import ValidationService from '../../../lib/validation';
import { emailSelector } from '../../../modules/SignUp/Login/reducer';
import { validateEmail, resendEmail } from '../../../modules/SignUp';
import { isLoadingSelector } from '../../../modules/LoadingStatus/reducer';

// @TODO Factoriser le code commun entre les deux containers
const validate = values => {
  return {
    _error: ValidationService.validateCode(values.code),
  };
};

const mapDispatchToProps = dispatch => ({
  onSubmit: values => {
    dispatch(validateEmail(values));
  },
  resendEmail: () => {
    dispatch(resendEmail());
  },
});

const mapStateToProps = state => ({
  email: emailSelector(state),
  isLoading: isLoadingSelector(state, 'validateEmail'),
});

const enhance = compose(connect(mapStateToProps, mapDispatchToProps), reduxForm({ form: 'validateEmail', validate }));
export default enhance(ValidateEmail);
